<template>
    <v-layout row>
      <v-flex xs12 sm12 offset-sm>
        <v-card>
          <v-toolbar class="primary white--text">
            <v-toolbar-title class="headline text-xs-center">
              Rate Category Management
            </v-toolbar-title>
            <v-spacer></v-spacer>  
            <v-card-actions class="justify-center">
              <v-btn 
                @click="dialog = true"
                outlined>
                <v-icon left color='teal'> add </v-icon>
                New Rate Category
              </v-btn>
            </v-card-actions>
            <!-- <router-link to="/Dashboard">
              <v-btn icon>
                <v-icon class="white--text">close</v-icon>
              </v-btn>
            </router-link> -->
          </v-toolbar>  
            
          <v-card>
              <template v-for="(item, index) in getCategories">
                <v-divider :key="item['.key']"></v-divider>
                <v-card :key="index">
                  <v-card-title col>
                  <v-flex xs11>
                    <v-card-text> 
                      Name :- <b>{{item.name}}</b> &nbsp; &nbsp; &nbsp; 
                    </v-card-text>
                  </v-flex>
                   <v-flex xs1>
                        <v-btn flat icon class="primary white--text" @click="editCategory(item)">
                      <v-icon primary title class="white--text">edit</v-icon>
                    </v-btn>
                   </v-flex>
                  </v-card-title>
                  <v-spacer/>
                  <v-card-actions>
                    <!-- <v-btn flat left icon class="primary white--text" @click="editAccount(item)">
                      <v-icon primary title class="white--text">edit</v-icon>
                    </v-btn>   -->
                    <!-- <v-btn flat icon class="primary white--text" @click="deleteAccount(item['.key'])">
                      <v-icon>delete</v-icon>
                    </v-btn> -->
                   
                  </v-card-actions>
                </v-card>
              </template>
            </v-card>
          </v-card>
      </v-flex>
      <v-dialog v-model="dialog" max-width="400">
        <v-card>
        <v-layout row>
        <v-flex xs12 sm12 offset-sm>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            {{ !isEdit ? 'Create Product Rate Category' : 'Edit Product Rate Category' }}
          </v-card-title>
          <form>
          <v-card-text>
             <v-layout row wrap >
               <v-flex xs12 sm12 md12>
                <v-text-field
                  name="name"
                  label="Category Name"
                  type="text"
                  v-model="currentCategory.name"
                  required></v-text-field>
               </v-flex>
             </v-layout>
          </v-card-text>
          </form>
          <v-spacer></v-spacer>
          <v-card-actions>  
            <v-spacer></v-spacer>
            <v-btn v-if="!isEdit" round large primary-title class="primary white--text" type="submit" @click="addNewCategory">
             <v-icon right dark>add_task</v-icon> Save 
            </v-btn>
            <v-btn v-else round large primary-title class="primary white--text" type="submit" @click="editCategorySave">
             <v-icon right dark>add_task</v-icon> Update 
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        </v-flex>
       
      </v-layout>
        </v-card>
      </v-dialog>
         <v-snackbar :timeout="timeout" top v-model="snackbar">
            {{message}}
          </v-snackbar>
    </v-layout>
  </template>
  
  <script>
  import { createNamespacedHelpers } from "vuex";
  const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
  import { cfirebase } from '../../../services/firebase.js'
  
  export default {
    data () {
      return {
        message: null,
        snackbar: false,
        timeout: 5000,
        dialog : null,
        name: '',
        isEdit: false,
        currentCategory : {
          name:null,
          brand:this.selectedBrand
        },
      }
    },
    computed:{
      ...mapGlobalGetters(['selectedBrand']),
      getCategories(){
        if (this.selectedBrand) {
          return this.productCategories.filter(item => item['brand'] === this.selectedBrand)
        }
      },
    },
    watch:{
    
    },
    created () {
      this.$bindAsArray(
        'productCategories',
        this.$root.$firebaseRefs.productRateCategory.orderByChild('brand').equalTo(this.selectedBrand)
      )
      if (this.$route.params.isNew) { 
       this.dialog = true
      }
    },
    destroyed () {
    },
    methods: {
      editCategory(item){
          this.isEdit = true;
          this.dialog = true;
          this.currentCategory = item;
      },
      editCategorySave(){
          let key = this.currentCategory['.key'];
          delete this.currentCategory['.key'];
          this.$root.$firebaseRefs.productRateCategory.child(key).update(this.currentCategory).then(data => {
              this.message = 'Category Edited Successful'
              this.snackbar = true
              this.dialog = false;
              this.isEdit = false;
              this.currentCategory = {
                 name: null,
                 brand : this.selectedBrand
             }
          })
          .catch(error => {
            this.message = error.message
            this.snackbar = true
            // Handle Errors here.
            var errorCode = error.code
            var errorMessage = error.message
            
            console.log(errorCode, errorMessage)
          })
      },
      addNewCategory() {
        this.currentCategory.brand = this.selectedBrand;
        this.$root.$firebaseRefs.productRateCategory.push(this.currentCategory).then(data => {
            if (this.$route.params.redirect) { 
             this.$router.push({ path: `/quick-invoice` });
            } else {
             this.message = 'Category Added Successful'
             this.snackbar = true
             this.dialog = false;
            }
          })
          .catch(error => {
            this.message = error.message
            this.snackbar = true
            // Handle Errors here.
            var errorCode = error.code
            var errorMessage = error.message
            
            console.log(errorCode, errorMessage)
          })
      }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/Settings/ProductRateCategory/productRateCategory.vue